import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ButtonLineComponent } from "../lines/buttonLineComponent";
/**
 * Cycles through a teleport entry's references without changing the selected node.
 */
export class TeleportInPropertyComponent extends React.Component {
    constructor() {
        super(...arguments);
        this._onUpdateRequiredObserver = null;
        this._onRebuildRequiredObserver = null;
    }
    componentDidMount() {
        this._onUpdateRequiredObserver = this.props.stateManager.onUpdateRequiredObservable.add(() => this.forceUpdate());
        this._onRebuildRequiredObserver = this.props.stateManager.onRebuildRequiredObservable.add(() => this.forceUpdate());
    }
    componentDidUpdate(previousProps) {
        if (previousProps.nodeData !== this.props.nodeData) {
            this._lastEndpoint = undefined;
        }
    }
    componentWillUnmount() {
        this.props.stateManager.onUpdateRequiredObservable.remove(this._onUpdateRequiredObserver);
        this.props.stateManager.onRebuildRequiredObservable.remove(this._onRebuildRequiredObserver);
    }
    _focusNextReference() {
        const endpoints = this.props.nodeData.invisibleEndpoints;
        if (!endpoints?.length) {
            return;
        }
        const index = (endpoints.indexOf(this._lastEndpoint) + 1) % endpoints.length;
        this._lastEndpoint = endpoints[index];
        this.props.stateManager.onFocusNodeObservable.notifyObservers(this._lastEndpoint);
    }
    render() {
        return _jsx(ButtonLineComponent, { label: "Focus next reference", isDisabled: !this.props.nodeData.invisibleEndpoints?.length, onClick: () => this._focusNextReference() });
    }
}
//# sourceMappingURL=teleportInPropertyComponent.js.map